import { useQuery, useMutation } from "@apollo/client";
import {
  AdminReportType,
  CreateTeacherGroupsClassroomsPupilsReportDocument,
  CreateTeacherGroupsClassroomsPupilsReportMutation,
  DeleteTeacherGroupsClassroomsPupilsReportDocument,
  DeleteTeacherGroupsClassroomsPupilsReportMutation,
  GetReportsDocument,
  GetReportsQuery,
} from "../../../generated/graphql";
import { useRequestError } from "../../../hooks";
import { Box, Grid } from "@material-ui/core";
import { ErrorMessageSnackbar } from "../../shared/ErrorMessageSnackbar";
import { LoadingProgress } from "../../shared/LoadingProgress";
import { ButtonCustom } from "../../shared/Style/Style";
import { ReportsContainer } from "../ReportsContainer";

export const TeachersPupilsReport = () => {
  const {
    data: adminReportsData,
    loading: adminReportsLoading,
    error: adminReportsError,
  } = useQuery<GetReportsQuery>(GetReportsDocument, {
    variables: { type: AdminReportType.TeacherGroupsClassroomsPupils },
    fetchPolicy: "network-only",
  });

  const [createAdminReport, {
    loading: adminReportCreationLoading,
    error: adminReportCreationError,
  }] = useMutation<CreateTeacherGroupsClassroomsPupilsReportMutation>(CreateTeacherGroupsClassroomsPupilsReportDocument, {
    refetchQueries: [{
      query: GetReportsDocument,
      variables: { type: AdminReportType.TeacherGroupsClassroomsPupils },
    }],
    errorPolicy: "all",
  });

  const [deleteAdminReport, {
    loading: adminReportDeletionLoading,
    error: adminReportDeletionError,
  }] = useMutation<DeleteTeacherGroupsClassroomsPupilsReportMutation>(DeleteTeacherGroupsClassroomsPupilsReportDocument, {
    errorPolicy: "all",
  });

  const adminReports = adminReportsData?.getReports ?? [];
  const latestAdminReport = adminReports[0] ?? {};
  const showAdminReports = !adminReportsLoading && !adminReportCreationLoading && !adminReportDeletionLoading;

  const isAdminReportsFull = adminReports.length > 0;

  const errors = adminReportsError || adminReportCreationError || adminReportDeletionError;
  const errorMessage = (adminReportsError && "Ошибка при загрузке отчета по учителям и урокам")
    || (adminReportCreationError && "Ошибка при создании отчета")
    || (adminReportDeletionError && "Ошибка при удалении отчета");

  const { requestError, setRequestError } = useRequestError(errors);

  const handleAdminReportsDeletion = async (id: string) => {
    try {
      await deleteAdminReport({ variables: { id } });
    } catch (e) {
      console.error(e);
    }
  };

  const handleAdminReportsCreation = async () => {
    try {
      if (isAdminReportsFull) {
        await handleAdminReportsDeletion(latestAdminReport.id);
      }
      await createAdminReport();
    } catch (e) {
      console.error(e);
    }
  };

  const loading = <LoadingProgress />;

  return (
    <ReportsContainer>
      <Grid container justifyContent="center" spacing={2}>
        <Grid xs={3} item>
          <h2>По учителям и урокам</h2>
        </Grid>
        <Grid xs={9} item>
          <Box display="flex" alignItems="center" height="100%">
            {showAdminReports ? (
              <>
                {isAdminReportsFull ? (
                  <Box marginRight={2}>
                    <a href={latestAdminReport.link}>Скачать отчет</a>
                  </Box>
                ) : null}
                <ButtonCustom width="220" onClick={handleAdminReportsCreation}>
                  Создать новый отчет
                </ButtonCustom>
              </>
            ) : loading}
          </Box>
        </Grid>
      </Grid>

      <ErrorMessageSnackbar
        open={requestError}
        message={errorMessage}
        closeHandler={() => setRequestError(false)}
      />
    </ReportsContainer>
  );
};
